import './broker-form.scss';
import DeleteIcon from '@mui/icons-material/DeleteForeverOutlined';

import { Box, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
type Props = {
  isBroker?: boolean;
  onClickDeactivate?: () => void;
};
export const InactiveWarning = ({ isBroker }: Props) => {
  return (
    <Box display="flex" alignItems="center" gap={1} sx={{ cursor: 'default' }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width={24}
        height={24}
        color="red"
      >
        <ErrorOutlineIcon fontSize="medium" />
      </Box>
      <Typography variant="h6" fontWeight="semi-bold" color="red">
        {isBroker ? 'BROKER' : 'BROKERAGE'} DEACTIVATED
      </Typography>
    </Box>
  );
};
export const DeactivateBrokerBrokerage = ({
  isBroker,
  onClickDeactivate,
}: Props) => {
  return (
    <span
      onClick={onClickDeactivate}
      style={{ display: 'flex', alignItems: 'center' }}
      data-testid="deactivate-broker-button"
    >
      <DeleteIcon
        sx={{
          height: '24px',
          width: '24px',
          marginRight: '4px',
          marginBottom: '2px',
        }}
      />
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 600,
        }}
      >
        DEACTIVATE {isBroker ? 'BROKER' : 'BROKERAGE'}
      </Typography>
    </span>
  );
};
